






























import BrowserMoreImg from '@/components/image/BrowserMoreImg.vue'
import Translation from '@/mixins/Translation'
import Assets from '@/mixins/Assets'
import BttPopup from '@/components/popup/btt/BttPopup.vue'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'

@Component({
  components: {BrowserMoreImg, BttPopup},
})

export default class AddToHomeScreenPopup extends Mixins(Translation, Assets) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: false, type: Boolean}) isSamsungBrowser: boolean

  open: boolean = true

  @Watch('value', {immediate: true})
  __value(value) {
    this.open = value
  }

  @Watch('open', {immediate: true})
  __open(value) {
    this.$emit('input', value)
  }

  close() {
    this.open = false
  }
}
